import { render, staticRenderFns } from "./Systembar.vue?vue&type=template&id=baf5e1e0"
import script from "./Systembar.vue?vue&type=script&lang=js"
export * from "./Systembar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports